// removed by extract-text-webpack-plugin
module.exports = {"ipad-portrait":"768px","mobile":"480px","red":"#e40000","dark-purple":"#4a2e5e","wrapper":"_2xdt5nCUXK3_EfPOmbFLGo","testimonialBg":"_2PvmYQvrEWjVgnZeGiKzB1","lb02":"wmDw5Y8Kwj5lC7KUUvFJc"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/OthersBanner/TestimonialsBanner/TestimonialsBanner.css
// module id = 1410
// module chunks = 0